import React, { useEffect } from "react";
import { motion } from "framer-motion";
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { stats } from "./data";

gsap.registerPlugin(ScrollTrigger);

const StatsSection = () => {

    useEffect(() => {
        // Animation des cartes de statistiques
        gsap.fromTo(".stat-card",
            {
                opacity: 0,
                y: 50
            },
            {
                opacity: 1,
                y: 0,
                duration: 0.8,
                stagger: 0.2,
                ease: "back.out(1.7)",
                scrollTrigger: {
                    trigger: ".stats-section",
                    start: "top 80%",
                    toggleActions: "play none none reverse"
                }
            }
        );
    }, []);

    return (
        <section className="py-20 relative overflow-hidden stats-section">

            <div className="container mx-auto px-4 relative z-10">

                <div className="grid grid-cols-2 md:grid-cols-4 gap-8">

                    {stats.map((stat, idx) => (

                        <motion.div
                            key={idx}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: idx * 0.1 }}
                            className="text-center stat-card"
                        >
                            {/* Icône */}
                            <div className="inline-flex p-4 rounded-2xl bg-gradient-to-br from-blue-500/20 to-cyan-500/20 mb-4">
                                {React.createElement(stat.icon, { className: "w-8 h-8 text-blue-400" })}
                            </div>

                            {/* Nombre */}
                            <div className="text-4xl md:text-5xl font-bold text-white mb-2">{stat.number}</div>

                            {/* Label */}
                            <div className="text-gray-300">{stat.label}</div>

                        </motion.div>

                    ))}

                </div>

            </div>

        </section>
    );
};

export default StatsSection;
